/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UpdateInputs */



/**
* | output |
* | --- |
* | "Update" |
*
* @param {UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update = /** @type {((inputs?: UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अद्यतन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar")
	return /** @type {LocalizedString} */ ("Update")
});